"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const DeleteRowSchemaColumnConfig_1 = tslib_1.__importDefault(require("../schema-column-config/DeleteRowSchemaColumnConfig"));
const GridConstants_1 = tslib_1.__importDefault(require("../GridConstants"));
const SchemaNavigationDefaultStrategy_1 = tslib_1.__importDefault(require("./SchemaNavigationDefaultStrategy"));
class SchemaLayout {
    constructor(schema) {
        this.grid = schema;
    }
    getDelegator() {
        return this.delegator;
    }
    setDelegator(delegator) {
        this.delegator = delegator;
    }
    data2Tr(data) {
        const idx = this.grid.getData().indexOf(data);
        return (idx > -1) ? this.grid.getElement(idx) : null;
    }
    data2DataRow(data) {
        const idx = this.grid.getData().indexOf(data);
        return this.grid.getTrFromDataRow(idx);
    }
    tr2Data(domRow) {
        const dataRow = domRow.getAttribute(GridConstants_1.default.GRID_ATTRIBUTE_DATAROW);
        if (dataRow === null || dataRow.length === 0) {
            return null;
        }
        // @ts-ignore
        return this.grid.getData()[dataRow];
    }
    tr2DataList(domRow) {
        let data = this.tr2Data(domRow);
        if (data === null) {
            return [];
        }
        return [data];
    }
    numInitialDomRows() {
        if (this.grid.dataManager.getDataRows() === null) {
            return 0;
        }
        return this.grid.dataManager.getDataRows().length;
    }
    isEmpty() {
        return this.numInitialDomRows() === 0;
    }
    getRowStyle(row) {
        return [];
    }
    getRowAttributes(row) {
        return `${GridConstants_1.default.GRID_ATTRIBUTE_DATAROW}="${row}"`;
    }
    getCellStyle(row, column) {
        this.initCellStyles();
        const cellStyle = [...this.cellStyles[column]];
        if (column === 0) {
            cellStyle.push(GridConstants_1.default.GRID_CELL_FIRST);
        }
        if (column === this.grid.gridConfig.getNumberOfColumns() - 1) {
            cellStyle.push(GridConstants_1.default.GRID_CELL_LAST);
        }
        return cellStyle;
    }
    initCellStyles() {
        if (this.cellStyles) {
            return;
        }
        const gridConfig = this.grid.gridConfig;
        this.cellStyles = Array.from({ length: gridConfig.columnConfigs.length }, (_, columnIndex) => {
            const style = [];
            style.push(`td-${columnIndex + 1}`);
            const columnConfig = gridConfig.getColumn(columnIndex);
            if (columnConfig.clickable) {
                style.push(GridConstants_1.default.EXPANDABLE);
            }
            if (columnConfig?.styles.length) {
                style.push(...columnConfig.styles);
            }
            if (columnIndex === this.grid.dataManager.getSortedByColumn()) {
                style.push(GridConstants_1.default.GRID_COLUMN_SORTED);
            }
            return style;
        });
    }
    getColSpan(row, column) {
        return this.grid.gridConfig.getColumn(column).getColSpan();
    }
    renderCell(tdElement, ctx, row, column) {
        const columnConfig = this.grid.gridConfig.getColumn(column);
        const data = this.grid.dataManager.getDataRow(row);
        const objectToDisplay = columnConfig.getData(data);
        const cssClasses = columnConfig.getTDCssClasses(data);
        if (cssClasses?.length) {
            tdElement.classList.add(...cssClasses);
        }
        fmko_ts_common_1.DOM.setElementTabbable(tdElement, true);
        tdElement.setAttribute("role", fmko_ts_common_1.ARIARole.GRID_CELL);
        columnConfig.renderer.render(ctx, objectToDisplay);
        const isDeleteRow = columnConfig instanceof DeleteRowSchemaColumnConfig_1.default;
        if (isDeleteRow) {
            tdElement.classList.add(GridConstants_1.default.DELETE_ROW_COLUMN);
        }
        SchemaNavigationDefaultStrategy_1.default.addCellNavigationListener({ schema: this.grid, tdElement, row, column });
    }
    dataChanged() {
        // Unused
    }
    getDelegate() {
        return null;
    }
    postRender() {
        const columnConfigs = this.grid.gridConfig.columnConfigs;
        for (const columnConfig of (columnConfigs || [])) {
            columnConfig.renderer?.postRender?.();
        }
        if (this.lastFocusedCell) {
            const { row, column } = this.lastFocusedCell;
            this.grid.getElement(row, column)?.focus();
        }
    }
    setLastFocusedCell(lastFocusedCell) {
        this.lastFocusedCell = lastFocusedCell;
    }
}
exports.default = SchemaLayout;
//# sourceMappingURL=SchemaLayout.js.map